class Form {
  constructor() {
    this.init()
  }

  init() {
    this.refreshAfterSubmit()
  }

  refreshAfterSubmit() {
    const button = document.querySelector('button.af-submit-button')

    button.addEventListener('click', () => {
      setTimeout(() => {
        window.location.reload()
      }, 5000)
    })
  }
}

export default Form
